export default {
  computed: {
    companiesQuickFilters() {
      return {
        title: 'Companies',
        filters: {
          columns: [
            {
              class: 'col-12 col-lg-6',
              filters: [
                {
                  name: 'company-brand-name',
                  label: this.$gettext('Brand/Commercial Name'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'name', 'ct', val.trim() ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'company-tin',
                  label: this.$gettext('TIN'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'tin', 'ct', val.trim() ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            },
            {
              class: 'col-12 col-lg-6',
              filters: [
                {
                  name: 'company-fiscal-name',
                  label: this.$gettext('Fiscal/Legal Name'),
                  type: 'text',
                  value: '',
                  callback: (val) => {
                    if (val.length > 0) {
                      return [[ 'business_name', 'ct', val.trim() ]]
                    } else {
                      return []
                    }
                  }
                },
                {
                  name: 'company-status',
                  label: this.$gettext('Company Status'),
                  type: 'radio-group',
                  options: [
                    {
                      text: this.$gettext('All'),
                      value: null
                    },
                    {
                      text: this.$gettext('Confirmed'),
                      value: 'confirmed'
                    },
                    {
                      text: this.$gettext('Pending'),
                      value: 'pending'
                    },
                    {
                      text: this.$gettext('Rejected'),
                      value: 'rejected'
                    }
                  ],
                  value: null,
                  stacked: false,
                  callback: (val) => {
                    if (val) {
                      return [[ 'status', 'eq', val ]]
                    } else {
                      return []
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    }
  }
}
